import React from 'react'

import { Helmet } from 'react-helmet'
import Gallery from '../components/gallery'

export default class ArtPage extends React.Component {
  render() {
    const { data } = this.props

    const images = []
    for (const { node: { name, childImageSharp } } of data.allFile.edges) {
      const index = parseInt(name, 10)
      images[index] = childImageSharp
    }

    return (
      <React.Fragment>
        <Helmet>
          <title>Coffee Art</title>
        </Helmet>

        <h2>Coffee Art</h2>
        <Gallery images={images} />
      </React.Fragment>
    )
  }
}

export const query = graphql`
  query galleryImages {
    allFile(
      filter: {
        sourceInstanceName: { eq: "img" }
        relativeDirectory: { eq: "coffee-art" }
      }
    ) {
      edges {
        node {
          name
          childImageSharp {
            resolutions(width: 140, height: 140) {
              ...GatsbyImageSharpResolutions
            }
            sizes {
              ...GatsbyImageSharpSizes
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/art.js